import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class UsageSettingsService {
  constructor(private http: HttpClient) {}

  createUsageSetting(data: { planName: string; feature: string; usageLimit: number; isActive?: boolean }): Observable<any> {
    const formData = new FormData();
    formData.append('planName', data.planName);
    formData.append('feature', data.feature);
    formData.append('usageLimit', data.usageLimit.toString());
    if (data.isActive !== undefined) {
      formData.append('isActive', data.isActive.toString());
    }
    return this.http.post(`${environment.authUrl}/usage-settings`, formData);
  }

  getUsageSetting(): Observable<any> {
    return this.http.get(`${environment.authUrl}/usage-settings`);
  }

  updateUsageSetting(id: number, data: { usageLimit?: number; isActive?: boolean }): Observable<any> {
    const formData = new FormData();
    if (data.usageLimit !== undefined) {
      formData.append('usageLimit', data.usageLimit.toString());
    }
    if (data.isActive !== undefined) {
      formData.append('isActive', data.isActive.toString());
    }
    return this.http.patch(`${environment.authUrl}/usage-settings/${id}`, formData);
  }
}
